// extracted by mini-css-extract-plugin
module.exports = {"dialog":"AddModDialog_dialog__z7K_n","button":"AddModDialog_button__afJSj"};